export default __webpack_public_path__ + "static/media/7SA511.20c33f75.jpg";